module.exports = __webpack_public_path__ + "static/media/socks.a8a3bf9d.svg";